import gql from 'graphql-tag';

const FRAGMENTS = gql`
  fragment ConferenceUser on users {
    user_type
    name  
    user_first_name
    user_last_name
    user_pic
  }
  fragment Conference on conference {
    id
    composition_sid
    created_at
    duration
    room_name
    media_url
    room_id
    type
    text
    conference_participants {
      user {
        ...ConferenceUser
      }
    }
  }
  fragment Chat on conference_chat {
    id
    room_id
    message
    created_at
    user {
      user_id
      user_type
      user_first_name
      avatar: user_pic
    }
  }
`;

export const GET_CONFERENCES = gql`
  query getConferences($sub: uuid!) {
    conferences: conference(
      where: {
        is_composite: { _eq: true }
        duration: { _gte: 300 }
        conference_participants: { user_sub: { _eq: $sub } }
      }
      order_by: [{ created_at: desc }]
    ) {
      ...Conference
    }
  }
  ${FRAGMENTS}
`;

export const GET_COACHES_CONFERENCES = gql`
  query getConferences($sub: uuid!) {
    conferences: conference(
      where: {
        is_composite: { _eq: true }
        duration: { _gte: 300 }
        conference_participants: {
          user_sub: { _eq: $sub }
          user: { user_type: { _neq: "fa" } }
        }
      }
      order_by: [{ created_at: desc }]
    ) {
      ...Conference
    }
  }
  ${FRAGMENTS}
`;

export const GET_MESSAGES_SUBSCRIPTION = gql`
  subscription getChat($roomId: String!) {
    chat: conference_chat(
      where: { room_id: { _eq: $roomId } }
      order_by: [{ created_at: asc }]
    ) {
      ...Chat
    }
  }
  ${FRAGMENTS}
`;

export const ADD_MESSAGE = gql`
  mutation addChat($data: conference_chat_insert_input!) {
    insert_conference_chat_one(object: $data) {
      ...Chat
    }
  }
  ${FRAGMENTS}
`;

export const CONF_HISTORY = gql`
  query confHistory(
    $limit: Int!
    $offset: Int!
    $order: [conference_order_by!]
    $userSub: uuid
  ) {
    rows: conference(
      where: {
        is_composite: { _eq: true }
        duration: { _gt: 100 }
        conference_participants: { user_sub: { _eq: $userSub } }
      }
      limit: $limit
      offset: $offset
      order_by: $order
    ) {
      id
      composition_sid
      duration
      created_at
      conference_participants {
        user {
          user_id
          user_first_name
          user_last_name
          name  
          user_type
        }
      }
    }
    count: conference_aggregate(
      where: {
        is_composite: { _eq: true }
        duration: { _gt: 100 }
        conference_participants: { user_sub: { _eq: $userSub } }
      }
    ) {
      aggregate {
        count
      }
    }
  }
`;

export const GET_CIRCLE_COACH_CONFERENCES = gql`
  query getCircleConferences($id: uuid!, $userSub: uuid) {
    conferences: conference(
      where: {
          is_composite: { _eq: true }
          duration: { _gte: 300 }
        _or: [
          {
            conference_participants: {
              user_sub: { _eq: $userSub }
              user: { user_type: { _neq: "fa" } }
            }
          }
          {
            room_name: { _eq: $id }
          }
        ]
      }
    ) {
      ...Conference
    }
  }
  ${FRAGMENTS}
`;

export const GET_CIRCLE_CONFERENCES = gql`
  query getCircleConferences($id: uuid!, $userSub: uuid) {
    conferences: conference(
      where: {
        is_composite: { _eq: true }
        duration: { _gte: 300 }
        _or: [
          {
            conference_participants: {
              user_sub: { _eq: $userSub }
            }
          }
          {
            room_name: { _eq: $id }
          }
        ]
      }
    ) {
      ...Conference
    }
  }
  ${FRAGMENTS}
`;
